import { Component, Input, OnInit } from '@angular/core';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';

@Component({
  selector: 'app-sgzp-app2change-password-sent',
  templateUrl: './sgzp-app2-change-password-sent.component.html',
  styleUrls: [
    './sgzp-app2-change-password-sent.component.css',
    '../style/global.css',
  ],
})
export class SgzpApp2ChangePasswordSentComponent implements OnInit {
  email: string;
  @Input()
  clientId: string;
  constructor() {}

  ngOnInit(): void {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  async passwordReset() {
    location.pathname = 'forgot-password';
  }

  async toLogin() {
    location.pathname = 'login';
  }
}
